import { IKogIcon } from "@/main/@types/interfaceIcons";

export function AnsweredAssignedIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 382.000000 350.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,350.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M2087 2718 l-638 -643 -302 307 c-166 168 -312 311 -324 317 -32 16
          -50 14 -73 -9 -45 -45 -40 -51 312 -410 183 -187 345 -344 360 -351 21 -9 35
          -9 56 0 43 18 1339 1320 1348 1354 10 43 -18 77 -64 77 -36 1 -55 -18 -675
          -642z"
				/>
				<path
					d="M2548 1339 l-1098 -1101 -572 576 c-555 559 -574 577 -610 576 -41 0
          -58 -19 -58 -67 0 -23 93 -121 602 -630 569 -569 605 -603 638 -603 33 0 93
          58 1163 1128 1090 1091 1127 1128 1127 1164 0 41 -19 58 -67 58 -24 1 -179
          -151 -1125 -1101z"
				/>
			</g>
		</svg>
	);
}
